import React from 'react';
import styled from 'styled-components';
import Header from './header';
import Footer from './footer';

const Layout = ({ children }) => {
	return (
		<Container>
			<Header />
			<Content>{children}</Content>
			<Footer />
		</Container>
	);
};

const Container = styled.div`
	width: 100%;
	height: 100%;
	overflow-x: hidden;
`;

const Content = styled.div`
	padding-top: 80px;

	display: flex;
	flex-direction: column;
	align-items: center;

	@media only screen and (max-width: 767.98px) {
		padding-top: 60px;
	}
`;

export default Layout;
